import React from 'react';
import { InfoIcon } from '@domain-group/fe-co-icon';
import { Tooltip as ToolTip } from '@domain-group/fe-blueprint-ui/tooltip';
import useIsDesktop from '../../../hooks/use-is-desktop';
import * as styles from './tooltip-search.style';

const TooltipSearch = (): JSX.Element => {
  const isDesktop = useIsDesktop();

  return (
    <ToolTip
      mouseEnterDelay={0.2}
      content={
        <span css={styles.tooltip(isDesktop)}>
          Total review count taken from past 12 months activity
        </span>
      }
      layer="layerFloating"
      placement={isDesktop ? 'bottom' : 'right'}
      trigger="hover"
    >
      <InfoIcon size="small" css={styles.infoIcon} />
    </ToolTip>
  );
};

export default TooltipSearch;
